import {DecimalPipe} from '@angular/common'
import {Component, computed, inject} from '@angular/core'

import {LoanType} from '@sparbanken-syd/loan-backend'
import {OccupationTypePipe} from '../../../pipes/occupation-type.pipe'
import {LoanPromiseStatus} from '../../../services/loan-promise-status'
import {LoanService} from '../../../services/loan.service'
import {KalpItemComponent} from '../kalp-item/kalp-item.component'

@Component({
  selector: 'spb-kalp-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['../kalp.component.scss'],
  imports: [
    KalpItemComponent,
    DecimalPipe,
    OccupationTypePipe
  ]
})
export class BasicInfoComponent {
  public readonly loanService = inject(LoanService)

  // Note that this component must never be loaded without an application
  public data = computed(() => this.loanService.application()!)

  public status = computed(() => {
    return new LoanPromiseStatus(this.data())
  })

  public blancoLoans = computed(() => {

    if (!this.data().loans) {
      return undefined
    }

    const blancoLoanTypes = new Set<LoanType>([LoanType.BLANCO, LoanType.CARD_CREDIT])
    return this.data().loans!.reduce((acc, loan) => {
      if (blancoLoanTypes.has(loan.type as LoanType)) {
        return acc + loan.amount
      }
      return acc
    }, 0)
  })

  public houseLoans = computed(() => {
    const data = this.loanService.application()
    if (!data?.loans) {
      return undefined
    }

    return data.loans.reduce((acc, loan) => {
      if (loan.type === LoanType.HOUSING) {
        return acc + loan.amount
      }
      return acc
    }, 0)
  })

  public ucIncomes = computed(() => {
    return this.data().applicants
      .map(a => a.uc?.income[0] ?? '0')
      .map(income => {
        return Number.parseInt(income) / 12
      })
  })
}
